/*
 * 스탬프의 시작 인덱스를 계산해주는 함수
 * 예를 들어, 스탬프가 10개 있으면 0을 반환하고, 11개 있으면 1을 반환
 */
export const getFrequencyStartIndex = (
  totalCount: number,
  cycleCount: number
) => {
  if (totalCount >= cycleCount && totalCount % cycleCount === 0) {
    return totalCount - cycleCount;
  }

  return totalCount - (totalCount % cycleCount); // 10의 배수 반환
};
